var map = {
	"./array.prototype.js": "./src/prototypes/array.prototype.js",
	"./number.prototype.js": "./src/prototypes/number.prototype.js",
	"./string.prototype.js": "./src/prototypes/string.prototype.js",
	"./vue.prototype.js": "./src/prototypes/vue.prototype.js",
	"./window.prototype.js": "./src/prototypes/window.prototype.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/prototypes sync \\.prototype\\.js$";